import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/dist/vuetify.min.css';

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            dark: {
                dark: true,
                colors: {
                    background: '#1a202e'
                }
            }
        }
    },
    display: {
        mobileBreakpoint: 'sm'
    }
});
